import { BusRoute } from '../../modules/API';

const fetchBusRoute = (options = {}) =>
  new Promise(async (resolve, reject) => {
    try {
      const { departFrom = {}, arriveTo = {} } = options;

      if (!departFrom.originBusStop && !(departFrom.lat && departFrom.lng)) {
        throw new Error(window.resolveLang('現在地を設定してください'));
      }
      if (!(arriveTo.lat && arriveTo.lng)) {
        throw new Error(window.resolveLang('目的地を設定してください'));
      }

      // default data
      departFrom.short_name = departFrom.title || window.resolveLang('現在地');
      departFrom.departure = departFrom.departure || moment().add(1, 'minutes');
      arriveTo.short_name = arriveTo.title || window.resolveLang('目的地');

      // call API
      try {
        // const { routetable } = await $.ajax({
        //   url: '/test/busRoute.json'
        // });
        const { routetable } = await callAPI({ departFrom, arriveTo });

        if (!routetable || routetable.length < 1) {
          throw new Error('no route');
        }

        // Parse Bus Route Data
        const routes = modules.parseBusRouteData(routetable, options);

        resolve({
          routes,
          departFrom,
          arriveTo
        });
      } catch (e) {
        // ================
        // if bus route error, do google walk
        // ================
        const routeData = [];
        routeData.push(modules.getMarkerData(departFrom));
        routeData.push(modules.getWalkData(departFrom, arriveTo));
        routeData.push(modules.getMarkerData(arriveTo));
        const routes = [{ route: routeData }];

        resolve({
          routes,
          departFrom,
          arriveTo
        });

        // throw new Error('ルートが見つかりませんでした。(E102)');
      }
    } catch (e) {
      reject(e);
    }
  });

// =========================================
// hepers
const callAPI = ({ departFrom, arriveTo } = {}) =>
  new Promise(async (resolve, reject) => {
    const minutes = departFrom.departure.hours() * 60;
    const currentTime = minutes + departFrom.departure.minutes();

    try {
      const { routetable } = await BusRoute({
        arriveTo,
        departFrom
      });

      const newRoutetable =
        routetable &&
        routetable.map(routeObj => {
          let src;
          let dst;
          const transit = [];

          let minusTime = 0;
          if (routeObj[0] && routeObj[0].departure) {
            minusTime = routeObj[0].departure - 15;
          }

          routeObj.forEach(
            (
              {
                name: short_name,
                jname,
                routename: route_name,
                routenumber: route_number,
                latitude,
                longitude,
                arrival,
                departure,
                path,
                color,
                routeids
              },
              index
            ) => {
              const obj = {
                short_name: short_name || jname,
                route_name,
                route_number,
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                arrival: arrival + (currentTime - minusTime),
                departure: departure + (currentTime - minusTime),
                path,
                color,
                routeids
              };

              if (index === 0) {
                src = obj;
              } else if (index === routeObj.length - 1) {
                dst = obj;
              } else {
                transit.push(obj);
              }
            }
          );

          return {
            src,
            transit,
            dst
          };
        });

      resolve({ routetable: newRoutetable || [] });
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });

const modules = {
  getCurrentMinutes: () => {
    const currentTime = moment();
    const hoursToMinutes = currentTime.hours() * 60;
    return hoursToMinutes + currentTime.minutes();
  },
  parseTime: minutes => {
    return moment()
      .startOf('day')
      .seconds(minutes * 60);
  },
  getMarkerData: marker => {
    const {
      lat,
      lng,
      short_name: title,
      subtitle,
      arrival,
      departure
    } = marker;

    return {
      marker: {
        lat,
        lng,
        title,
        subtitle,
        arrival,
        departure
      }
    };
  },
  getWalkData: (origin, destination) => ({
    walk: {
      origin: {
        lat: origin.lat,
        lng: origin.lng
      },
      destination: {
        lat: destination.lat,
        lng: destination.lng
      },
      departure: origin.departure || origin.arrival,
      arrival: destination.arrival || destination.departure
    }
  }),
  getRouteData: (departureBS, arrivalBS) => {
    // const polyline = [
    //   {
    //     lat: departureBS.latitude,
    //     lng: departureBS.longitude
    //   }
    // ];

    // if (arrivalBS.points) {
    //   arrivalBS.points.map(point => {
    //     polyline.push({
    //       lat: point.latitude,
    //       lng: point.longitude
    //     });
    //   });
    // }

    // polyline.push({
    //   lat: arrivalBS.latitude,
    //   lng: arrivalBS.longitude
    // });

    const polyline = google.maps.geometry.encoding.decodePath(arrivalBS.path);

    return {
      route: {
        companyid: departureBS.companyid,
        route_name: departureBS.route_name,
        route_number: departureBS.route_number,
        color: departureBS.color,
        polyline,
        departure: departureBS.departure,
        arrival: arrivalBS.arrival
      }
    };
  },
  parseBusRouteData: (routetable = [], { departFrom, arriveTo } = {}) => {
    const routes = [];

    routetable.forEach(route => {
      if (
        !route.src ||
        !route.src.departure ||
        !route.dst ||
        !route.dst.arrival
      ) {
        return;
      }

      const routeData = [];
      let previousBS = null;

      const dbsDepartureTime = modules.parseTime(route.src.departure);
      const departureBS = {
        ...route.src,
        arrival:
          (route.src.arrival && modules.parseTime(route.src.arrival)) ||
          dbsDepartureTime,
        departure: dbsDepartureTime,
        lat: route.src.latitude,
        lng: route.src.longitude
      };

      const absArrivalTime = modules.parseTime(route.dst.arrival);
      const arrivalBS = {
        ...route.dst,
        arrival: absArrivalTime,
        departure:
          (route.dst.departure && modules.parseTime(route.dst.departure)) ||
          absArrivalTime,
        lat: route.dst.latitude,
        lng: route.dst.longitude
      };

      // =======================
      // departFrom
      if (
        departFrom &&
        !departFrom.originBusStop &&
        departFrom.lat &&
        departFrom.lng &&
        (departFrom.lat !== departureBS.lat ||
          departFrom.lng !== departureBS.lng) &&
        !departFrom.skipWalkingToBusStop
      ) {
        // departFrom is different from departureBusStop
        routeData.push(modules.getMarkerData(departFrom));

        routeData.push({
          walk: {
            ...modules.getWalkData(departFrom, departureBS).walk,
            adjustDeparture: true
          }
        });
      }

      // =======================
      // src
      routeData.push(modules.getMarkerData(departureBS));
      previousBS = departureBS;

      // ===========================
      // transit
      if (route.transit) {
        route.transit.forEach(transit => {
          transit = {
            ...transit,
            arrival: transit.arrival && modules.parseTime(transit.arrival),
            departure:
              transit.departure && modules.parseTime(transit.departure),
            lat: transit.latitude,
            lng: transit.longitude
          };

          if (transit.arrival) {
            routeData.push(modules.getRouteData(previousBS, transit));
          }

          if (transit.departure && !transit.arrival) {
            routeData.push(modules.getWalkData(previousBS, transit));
          }

          transit.arrival = transit.arrival || transit.departure;
          transit.departure = transit.departure || transit.arrival;

          routeData.push(modules.getMarkerData(transit));
          previousBS = transit;
        });
      }

      // ===========================
      // dst
      routeData.push(modules.getRouteData(previousBS, arrivalBS));
      routeData.push(modules.getMarkerData(arrivalBS));

      // =======================
      // arriveTo
      if (
        arriveTo &&
        arriveTo.lat &&
        arriveTo.lng &&
        (arriveTo.lat !== arrivalBS.lat || arriveTo.lng !== arrivalBS.lng)
      ) {
        // arriveTo is different from route.src - has to do google direction
        routeData.push(modules.getWalkData(arrivalBS, arriveTo));

        routeData.push(modules.getMarkerData(arriveTo));
      }

      routes.push({
        route: routeData
      });
    });

    return routes;
  }
};

export default fetchBusRoute;
